import React from 'react';

import {
    Container,
    Row,
    Col, Input, Label, Modal, ModalBody, ModalHeader, FormGroup, Button, ButtonToggle, ModalFooter
} from 'reactstrap';

import { Rnd } from 'react-rnd';

import Isvg from 'react-inlinesvg'

import addIcon from '../../assets/svg/add-icon.svg';

import PreviewComponent from '../landingBuilder/previewComponent';


import defaultJson from '../landingBuilder/default.json'
import defaultInformationJson from '../landingBuilder/defaultInfoPages.json'
import defaultLoginJson from '../landingBuilder/defaultLogin.json'


import FormBuilder from '../../components/forms/formBuilderFooter';
import FormBuilderHeader from '../../components/forms/formBuilderHeader';



import { Player, Controls } from "@lottiefiles/react-lottie-player";

import warrning from '../../assets/images/warrning.png';


import Toggle from '../../components/forms/fields/toggle';
import { API_ENDPOINT } from '../../constants';
import { v4 as uuidv4 } from 'uuid';
import { copyMobileToApp } from './landingHelper';

import AppBuilder from '../../appBuilder/appBuilder'

function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status,

        }
    })
}

class InformationPageLandingBuilder extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,
            infoPage: true,
            reset1: false,
            reset2: false,
            reset3: false,
            name: '',
            typeConf: 1,
            layout: 'lg',
            ifChange: false,
            libraryIcons: []

        }
    }



    // update = () => {
    //     this.setState(
    //         {
    //             showPlayer: true,
    //         },
    //         () => {

    //             let data = {};
    //             if (this.state.tabIndex !== 4) {


    //                 data.landingJSON_v2 = this.state.landingJSON;
    //                 data.informationJSON_v2 = this.state.informationJSON;
    //                 data.loginJSON_v2 = this.state.loginJSON;

    //                 data.groupId = this.props.selectedGroup;
    //                 data.clinic = this.props.selectedClinic;
    //                 this.player.current.play();
    //                 fetch(API_ENDPOINT + '/users/account/updateClinicDataLanding', {
    //                     method: 'POST',
    //                     headers: {
    //                         'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
    //                         'content-type': 'application/json'
    //                     },
    //                     body: JSON.stringify(data)
    //                 }).then(parseJSON).then(({ result, status }) => {
    //                     if (result.error) {
    //                         this.setState({ error: result.error })
    //                     } else {
    //                         this.setState({
    //                             showPlayer: false,
    //                             showPlayer2: true,
    //                         },
    //                             () => {
    //                                 setTimeout(() => {
    //                                     this.setState({ showPlayer2: false });
    //                                 }, 1000);
    //                             })

    //                         if (this.props.changeLinkModal) {
    //                             this.props[0].history.push(this.props.changeLinkModal)
    //                             this.props.abortAction()
    //                         } else {
    //                             this.props.onChange('done')
    //                             this.props.abortAction()
    //                         }



    //                         this.props.verifyUser(() => { }, () => {
    //                             this.props.changeGroup(data.groupId)
    //                         });
    //                     }

    //                 })
    //             }


    //         }
    //     )
    // };

    getLibraryIcons = () => {
        fetch(API_ENDPOINT + '/data-managment/landing-builder-styles/library/icons', {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
        }).then(parseJSON).then(({ result, status }) => {
            if (status >= 200 && status < 300) {
                if (result && result.gallery) {
                    this.setState({
                        libraryIcons: result.gallery,
                        loadLibrary: false
                    })
                } else {
                    this.setState({
                        libraryIcons: [],
                        loadLibrary: false
                    })
                }


            }

        })
    }

    get = () => {
        if (this.props.landingStyle) {
            this.setState({
                informationJSON: this.props.landingStyle ?? {},
            }, () => this.setState({ updateNeeded: uuidv4() }))
        }

        this.getLibraryIcons();
        setTimeout(() => {
            this.setState({
                ifChange: true
            })
        }, 2000)



    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.landingStyle != this.props.landingStyle) {
            this.get()

        }
        if (this.props.updateLanding) {
            // this.update()

            // this.props.changeUpdateLanding(false)
        }

    }

    componentDidMount() {
        this.get()

    }

    setReset = () => {
        this.setState({
            informationJSON: defaultInformationJson,
            reset: null
        }, () => {
            if (this.props.updateLandingStyle) this.props.updateLandingStyle(this.state.informationJSON)
            this.setState({ updateNeeded: uuidv4() })
        })
    }

    /**
    * Import landing page template and update landing page style
    * @author   Aleksandar Dabic
    */
    importTemp = () => {

        let item = this.props.templates.filter(item => item._id == this.state.selectedTemp)[0];

        this.setState({ informationJSON: item.informationJSON, importModal: false, selectedTemp: null }, () => {
            if (this.props.updateLandingStyle) this.props.updateLandingStyle(this.state.informationJSON)
            this.setState({ updateNeeded: uuidv4() })
        })

    }




    render() {
        let selectedGroupIdx = 0;
        if (this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = selectedGroupIdx ? this.props?.uData?.clinicGroups?.[selectedGroupIdx] : null;
        const enterprise = groupData?.enterprise || false;
        const listing = groupData?.listing || false;

        return (
            <div style={{ marginTop: 50 }}>


                <div className="tabs-buttons-wrap2">
                    <div className='left-buttons'></div>

                    <div className='right-buttons'>
                        <div style={{ height: 33, width: 200, marginTop: -18 }}>
                            <Toggle value={this.state.preview} label={"Preview".translate(this.props.lang)} onChange={(e) => {
                                this.setState({ preview: !this.state.preview, importModal: false }, () => {
                                })
                            }} />
                        </div>

                        {
                            this.props.saveHandler ?
                                <Button className='tab-button acitve-tab-button' disabled={this.props.loadingSave} onClick={() => this.props.saveHandler()}>
                                    {/* {"Save".translate(this.props.lang)} */}
                                    {
                                        this.props.showPlayer ? (
                                            <Player
                                                onEvent={(event) => {
                                                    // if (event === "load") this.stopAnimation();
                                                }}
                                                // onStateChange={this.toggleVisibility}
                                                ref={this.player} // set the ref to your class instance
                                                autoplay={true}
                                                loop={true}
                                                controls={true}
                                                src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                style={{ height: "20px", width: "20px" }}
                                            ></Player>

                                        ) : this.props.showPlayer2 ? (
                                            <div style={{ display: 'flex', alignItems: 'center' }}><Player
                                                // onStateChange={this.toggleVisibility}
                                                ref={this.player2} // set the ref to your class instance
                                                autoplay={true}
                                                loop={true}
                                                controls={true}
                                                src="https://assets10.lottiefiles.com/packages/lf20_CxyxLk.json"
                                                style={{ height: "20px", width: "20px" }}
                                            ></Player>
                                                {'Saved'.translate(this.props.lang)}
                                            </div>
                                        ) : (
                                            "Save".translate(this.props.lang)
                                        )
                                    }
                                </Button>
                                :
                                null
                        }



                        {
                            this.props[0].match.params.id != 'new' ?
                                <>
                                    <Button className='tab-button acitve-tab-button' onClick={() => this.setState({ reset: true })}>{"Reset".translate(this.props.lang)}</Button>
                                </>
                                :
                                null
                        }
                        {/* <Button className='tab-button acitve-tab-button' onClick={() => this.setState({ importModal: true, preview: false })}>{"Import".translate(this.props.lang)}</Button> */}



                    </div>
                </div>
                <div style={{ visibility: this.state.preview || this.state.importModal ? 'hidden' : 'visible', height: this.state.preview || this.state.importModal ? '0' : 'auto' }}>
                    <AppBuilder
                        selectedClinic={this.props.selectedClinic}
                        selectedGroup={this.props.selectedGroup}
                        json={this.state.informationJSON ? this.state.informationJSON : {}}
                        location={this.props[0].location.pathname}
                        libraryIcons={this.state.libraryIcons}
                        handleChange={(json) => {
                            if (this.state.ifChange) {
                                // this.props.onChange('open')
                                this.setState({
                                    ifChange: false
                                })
                            } else {
                            }
                            this.setState({
                                informationJSON: json,
                            }, () => {
                                if (this.props.updateLandingStyle) this.props.updateLandingStyle(this.state.informationJSON)
                            })
                        }}
                        changeLayout={(layout) => {
                            this.setState({
                                layout: layout
                            })
                        }}
                        importMobileToApp={(nodes) => {
                            let newNodes = copyMobileToApp(nodes)
                            if (this.state.ifChange) {
                                // this.props.onChange('open')
                                this.setState({
                                    ifChange: false
                                })
                            }
                            this.setState({
                                informationJSON: JSON.parse(JSON.stringify(newNodes)),
                                updateNeeded: uuidv4()
                            }, () => {
                                if (this.props.updateLandingStyle) this.props.updateLandingStyle(this.state.informationJSON)
                            })
                        }}
                        layout={this.state.layout}
                        key={2}
                        updateNeeded={this.state.updateNeeded}
                        lang={this.props.lang}
                        preview={this.state.preview}
                        enterprise={enterprise}
                        listing={listing}
                        uData={this.props.uData}

                    />
                </div>
                {
                    this.state.preview ?
                        <div className="preview-landing-wrap">
                            <div className={this.state.layout == 'xs' || this.state.layout == 'app' ? 'preview-xs-size' : this.state.layout == 'sm' ? 'preview-sm-size' : 'preview-lg-size'}>
                                <PreviewComponent
                                    layout={this.state.layout}
                                    nodes={JSON.parse(JSON.stringify(this.state.informationJSON))} />
                            </div>
                        </div>
                        :
                        null
                }

                {this.state.reset ?
                    <Modal isOpen={this.state.reset} style={{ marginTop: '50px' }} centered>

                        <ModalBody className="delete-modal">
                            <div>{'Are you sure you want reset information page?'.translate(this.props.lang)}</div>
                        </ModalBody>
                        <ModalFooter className='buttons-right-blue'>
                            <Button color='primary' style={{ margin: 5, backgroundColor: "#3A3F56", minWidth: 100 }} onClick={() => this.setReset()}>{'Yes'.translate(this.props.lang)}</Button>
                            <Button color='primary' style={{ margin: 5, minWidth: 100 }} onClick={() => this.setState({ reset: !this.state.reset })}>{'No'.translate(this.props.lang)}</Button>

                        </ModalFooter>
                    </Modal>
                    : null}



                {
                    this.state.importModal ?

                        <>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                                <div style={{ fontSize: 24, cursor: 'pointer' }} onClick={() => this.setState({ importModal: !this.state.importModal, selectedTemp: null })}>&times;</div>
                            </div>
                            {

                                this.props.templates && this.props.templates.map((item, idx) => {
                                    return (
                                        <FormGroup style={{ position: 'relative' }}>
                                            <hr />
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <Label>{item.name}</Label>

                                                <Button color='primary' style={{ margin: 5, }} onClick={() => { this.setState({ selectedTemp: item._id }, () => this.importTemp()) }}>{'Import'.translate(this.props.lang)}</Button>

                                            </div>
                                            <hr />
                                            <div className="import-modal-items">
                                                <div className="preview-landing-wrap">
                                                    <div className={this.state.layout == 'xs' || this.state.layout == 'app' ? 'preview-xs-size' : this.state.layout == 'sm' ? 'preview-sm-size' : 'preview-lg-size'}>
                                                        <PreviewComponent
                                                            layout={this.state.layout}
                                                            nodes={JSON.parse(JSON.stringify(item.informationJSON))}
                                                        />
                                                    </div>
                                                </div>

                                            </div>


                                        </FormGroup>
                                    )
                                })


                            }

                        </>
                        : null
                }





            </div>

        )
    }
}

export default InformationPageLandingBuilder;